import create from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import immer from "./immer"
let appStore = (set) => ({
    loading: false,
    text: "",
    showLoading: (text) => {
        set((state) => {
            state.loading = true;
            if (text) {
                state.text = text;
            }
        })
    },
    hideLoading: () => {
        set((state) => {
            state.loading = false;
        })
    },
})

appStore = devtools(appStore, { name: "app" })
appStore = immer(appStore)
export default create(appStore);
